<template>
  <portal-context-required-template>
    <page-title />
    <payment-details />
    <paid-invoices-table class="_pb0" />
    <div
      container
      class="_pbm _flex justify-center align-center"
    >
      <router-link class="_mlxs btn --sm" :to="{ name: 'make-payment' }"
        >Make Another Payment?</router-link
      >
    </div>
  </portal-context-required-template>
</template>

<script>
  import PageTitle from './PaymentConfirmation/PageTitle'
  import PaymentDetails from './PaymentConfirmation/PaymentDetails'
  import PaidInvoicesTable from './PaymentConfirmation/PaidInvoicesTable'
  import billing from '@mixins/billing'
  import { GET_PAYMENT_HISTORY } from '@store/modules/billing/actionTypes'
  import fetchable from '@mixins/fetchable'

  export default {
    mixins: [billing, fetchable],
    components: {
      PageTitle,
      PaymentDetails,
      PaidInvoicesTable
    },
    computed: {
      validPaymentId () {
        if ('paymentId' in this.$route.query) { return this.$route.query.paymentId.length } else { return this.payment.transactionId.length }
      },
      fetchers () {
        return [
          {
            action: GET_PAYMENT_HISTORY,
            shouldFetch: this.validPaymentId,
            options: {
              params: {
                paymentId: this.$route.query.paymentId || this.payment.transactionId,
                invoiceNumber: ''
              }
            }
          }
        ]
      }
    },
    created () {
      if (!(this.validPaymentId)) {
        this.$store.commit('SET_ANNOUNCEMENT_WARNING', true)
        this.$store.commit('SET_ANNOUNCEMENT', this.$route.query.userMessage)
        this.$router.push({ name: 'billing-overview' })
      }
    }
  }
</script>
